module.exports = __webpack_public_path__ + "media/images/community__tease__deco--desktop-9a63b42abbf5d385eef10e1becd286e2.png";